module.exports = __webpack_public_path__ + "img/full2-min.814d9ca7.png";